import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollUtils';

const Footer = () => {
  const navigate = useNavigate();

  // Handle policy link clicks with consistent behavior
  const handlePolicyLinkClick = (e, path) => {
    e.preventDefault();
    
    // First navigate to the page
    navigate(path);
    
    // Then scroll after a consistent delay to ensure component is mounted
    setTimeout(() => {
      const policyTop = document.getElementById('policy-top');
      if (policyTop) {
        policyTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Fallback to window scrollTo if element not found
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="bg-primary text-white py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-8 md:mb-0">
            <Link to="/" className="flex items-center mb-4">
              <span className="text-2xl font-bold text-white">senti</span>
              <span className="text-2xl font-bold text-accent">.care</span>
            </Link>
            <p className="max-w-xs">
              Pioneering healthcare's future through our Large Biosignal Model (LBM) technology.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold text-lg mb-4">Company</h3>
              <ul className="space-y-2">
              <li><Link to="/" className="hover:text-accent">Home</Link></li>
              <li><Link to="/technology" className="hover:text-accent">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-accent">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-4">Technology</h3>
              <ul className="space-y-2">
                <li><Link to="/technology" className="hover:text-accent">Our LBM</Link></li>
                <li><Link to="/applications" className="hover:text-accent">Applications</Link></li>
                <li><Link to="/technology" className="hover:text-accent">Research</Link></li>
                <li><Link to="/technology" className="hover:text-accent">Innovations</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-4">Connect</h3>
              <ul className="space-y-2">
                <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
                <li>
                  <Link 
                    to="/investors" 
                    className="hover:text-accent"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/investors');
                      setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 100);
                    }}
                  >
                    Investors
                  </Link>
                </li>
                <li><Link to="/partners" className="hover:text-accent">Partners</Link></li>
                <li><Link to="/contact" className="hover:text-accent">Support</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p>© {new Date().getFullYear()} Senti. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a 
              href="/privacy" 
              className="hover:text-accent"
              onClick={(e) => handlePolicyLinkClick(e, '/privacy')}
            >
              Privacy Policy
            </a>
            <a 
              href="/terms" 
              className="hover:text-accent"
              onClick={(e) => handlePolicyLinkClick(e, '/terms')}
            >
              Terms of Service
            </a>
            <a 
              href="/cookies" 
              className="hover:text-accent"
              onClick={(e) => handlePolicyLinkClick(e, '/cookies')}
            >
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;